import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { Eyebrow, Reveal } from "../components/Shared";
import { IMAGES } from "../data/site";

const CraftStatement = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.85", "end 0.45"] });
  const boldOpacity = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <div ref={ref} className="relative mt-20" data-testid="craft-statement">
      <p className="font-display text-3xl font-semibold leading-snug tracking-tight text-line sm:text-5xl lg:text-6xl">
        Printing is not merely a process.
        <br />
        It is a craft.
      </p>
      <motion.p
        style={{ opacity: boldOpacity }}
        className="absolute inset-0 font-display text-3xl font-semibold leading-snug tracking-tight text-navy sm:text-5xl lg:text-6xl"
        aria-hidden="true"
      >
        Printing is not merely a process.
        <br />
        It is a <span className="text-brand">craft.</span>
      </motion.p>
    </div>
  );
};

const AboutSection = () => (
  <section className="relative overflow-hidden bg-canvas py-24 sm:py-32" data-testid="about-section">
    <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid gap-16 lg:grid-cols-2">
        <div>
          <Reveal>
            <Eyebrow>01 — About Executive Print Group</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display text-2xl font-bold tracking-tight text-navy sm:text-3xl lg:text-4xl">
              An established printing house built on quality, precision and trust.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-base leading-relaxed text-slate sm:text-lg">
              Executive Print Group stands as one of Bangalore's trusted names in the printing industry. Over the
              years, we have built our reputation through uncompromising quality, timely execution and client-focused
              service.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <p className="mt-4 text-base leading-relaxed text-slate">
              Every project is treated with meticulous care — combining technology, precision and craftsmanship at
              each stage of production.
            </p>
          </Reveal>
          <Reveal delay={0.4}>
            <Link to="/about" data-testid="about-discover-btn" className="btn-secondary group mt-10">
              Discover Our Story
              <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
            </Link>
          </Reveal>
        </div>
        <Reveal delay={0.2} className="relative">
          <div className="relative overflow-hidden rounded-2xl border border-line bg-white shadow-sm">
            <img
              src={IMAGES.operator}
              alt="Print professional at work inside the production facility"
              className="h-full max-h-[520px] w-full object-cover transition-transform duration-700 hover:scale-105"
              loading="lazy"
            />
            <div className="absolute bottom-4 left-4 rounded-xl border border-line bg-white/90 px-5 py-3.5 backdrop-blur-md">
              <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-brand">Sudhamanagar</p>
              <p className="mt-0.5 font-display text-sm font-semibold text-navy">Bangalore — 560027</p>
            </div>
          </div>
        </Reveal>
      </div>
      <div className="max-w-4xl">
        <CraftStatement />
      </div>
    </div>
  </section>
);

export default AboutSection;
